import { render, staticRenderFns } from "./nfcLaunch.vue?vue&type=template&id=345aafb5&scoped=true"
import script from "./nfcLaunch.vue?vue&type=script&lang=js"
export * from "./nfcLaunch.vue?vue&type=script&lang=js"
import style0 from "./nfcLaunch.vue?vue&type=style&index=0&id=345aafb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345aafb5",
  null
  
)

export default component.exports